import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../Environments/environment.dev';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PatientOnboarding {
  private baseUrl = environment.apiUrl;
  private getHeader() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }
  constructor(private http: HttpClient) { }
  // getValidatePatientPortalLoginGUIDToken(token: any): Observable<any> {
  //   const params = new HttpParams().set('token', token);
  //   return this.http.post<any>(
  //     `${this.baseUrl}/Patient/ValidatePatientPortalLoginGUIDToken`,
  //     { params, ...this.getHeader() }
  //   );
  // }
  getValidatePatientPortalLoginGUIDToken(token: string): Observable<any> {
    const params = new HttpParams().set('token', token);

    return this.http.post<any>(
      `${this.baseUrl}/Patient/ValidatePatientPortalLoginGUIDToken`,
      { token },
      {
        params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }
  generateOtpForPatientPortal(req: any): Observable<any> {

    const params = new HttpParams()
      .set('MobileNumber', req.MobileNumber)
      .set('EmailId', req.EmailId)
      .set('CountryCode', req.CountryCodeforMobile)
      .set('OrganizationName', req.OrganizationName);

    return this.http.get(
      `${this.baseUrl}/MasterPatient/GenerateOtpForPatientPortal`,
      { params }
    );
  }
  
  validatePatientAppOTP(obj: 
    {reqMobileNo: string; Otp: string; SubOrganizationId: number;}): Observable<any> {
    const params = new HttpParams()
      .set('MobileNumber', obj.reqMobileNo)
      .set('OTP', obj.Otp)
      .set('SubOrganizationId', obj.SubOrganizationId.toString());

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
      // add Authorization if needed
    });
    return this.http.get(
      `${this.baseUrl}/MasterPatient/USValidatePatientAppOTPForWeb`,
      { params, headers }
    );
  }

}
